import { appRoutes } from 'features/app/routes/paths';

export const tutorialsPaths = Object.freeze({
  static: {
    root: `${appRoutes.static.root}/tutorials`,
  },
});
